

export const mainColours = ["red", "orange", "amber", "yellow", "lime", "green", "emerald", "teal", "cyan", "sky", "blue", "indigo", "violet", "purple", "fuchsia", "pink", "rose"] as const;
export const neutralColours = ["slate", "gray", "zinc", "neutral", "stone"] as const;
export const colours = [...mainColours, ...neutralColours] as const;
export type Colours = (typeof colours)[number];
export function isValidColour(colour: string | any): Colours | false {
    return colours.includes(colour as any) ? colour as Colours : false;
}